import { uint16, uint32, uint8 } from '../../utils';
import { enumGroupType } from '../dataSource';

export const genWidgetBin = (item: any) => {
  const widgetName = Buffer.alloc(32); //创建一个长度为32的空buffer
  if (item.widgetName) {
    if (item.translateWidgetNameUid) {
      const uid = item.translateWidgetNameUid.readUInt32LE();
      widgetName.writeUInt32LE(0xffffffff, 0);
      widgetName.writeUInt32LE(uid, 4);
    } else {
      widgetName.write(item.widgetName);
    }
  }
  let widgetBg;
  if (item.bg) {
    widgetBg = item.bg;
  } else if (item.bgColor) {
    //如果存在bgColor的话
    widgetBg = uint32(item.bgColor);
  } else {
    widgetBg = uint32(0);
  }

  const flex_direction = item.flex_direction == 'row' ? 0 : 1;
  // 主轴
  const justify_content =
    item.justify_content == 'center'
      ? 1
      : item.justify_content == 'flex-start'
      ? 0
      : 2;
  // 交叉
  const align_content =
    item.align_content == 'center'
      ? 1
      : item.align_content == 'flex-start'
      ? 0
      : 2;
  // 元素间 默认center
  const align_items =
    item.align_items == 'center' ? 1 : item.align_items == 'flex-start' ? 0 : 2;

  const gap = Number(item.gap);
  let alignId = Buffer.alloc(0);
  if (item.isAlign) {
    alignId = uint32(
      flex_direction +
        (justify_content << 2) +
        (align_content << 5) +
        (align_items << 8) +
        (Math.abs(gap) << 11) +
        ((gap < 0 ? 1 : 0) << 20)
    );
  }
  const w = item.w ? Number(item.w) : 0;
  const h = item.h ? Number(item.h) : 0;
  const whId = uint32((w << 16) + h);
  let alignFlag;
  if (item.isAlign) {
    alignFlag = true;
  } else {
    alignFlag = false;
  }
  const uidIconImg = item.icon; //icon
  const uidEditBoxImg = item.editBox; //editBox
  const uidJs = item.widgetJsUid; // js文件
  const args = item.args; // 跳转运动或js参数
  const widgetUidPreviewImg = item.preview; //预览图

  const widgetRecordCount =
    // 普通widget的跨元素对齐和自定义小部件widget底下的count是用uidable.length判断
    // 自定义小部件底下的款元素对齐的是用itemUidTable.length判断
    item.uidTable && item.uidTable?.length > 0
      ? uint8(item.uidTable?.length)
      : item.itemUidTable && item.itemUidTable.length > 0
      ? uint8(item.itemUidTable?.length)
      : uint8(0);

  let groupType = uint8(0); //对应groupType
  let binGroupType: number;
  if (item.translateGroupTypeUid) {
    const groupTypeList = item.groupType.split('_');
    binGroupType = enumGroupType.findIndex((id) => {
      return id == groupTypeList[0].replace('@', '');
    });
  } else {
    binGroupType = enumGroupType.findIndex((id) => {
      return id == item.groupType;
    });
  }
  if (binGroupType > -1) {
    groupType = uint8(binGroupType);
  }
  const bgFlag = item.bg ? 0 : 1;
  const enableJumpFlag = 0;
  let widgetFlags = (enableJumpFlag << 1) + bgFlag;

  if (!item.jumpApp && !item.minClickZone) {
    widgetFlags = 0;
  } else {
    widgetFlags =
      item.jumpApp || item.minClickZone
        ? widgetFlags + (1 << 1)
        : widgetFlags & ~(1 << 1);
  }
  widgetFlags = uidEditBoxImg
    ? widgetFlags + (1 << 2)
    : widgetFlags & ~(1 << 2);
  widgetFlags = uidIconImg ? widgetFlags + (1 << 3) : widgetFlags & ~(1 << 3);
  widgetFlags = w && h ? widgetFlags + (1 << 12) : widgetFlags & ~(1 << 12);
  widgetFlags =
    uidJs || args ? widgetFlags + (1 << 13) : widgetFlags & ~(1 << 13);
  widgetFlags = alignFlag ? widgetFlags + (1 << 14) : widgetFlags & ~(1 << 14);
  const hasOptionFlags = !!item.translateGroupTypeUid || !!item.minClickZone;
  let hasOptionFlagsValue = 0;
  if (hasOptionFlags) {
    if (item.translateGroupTypeUid) {
      hasOptionFlagsValue = 1;
    }
    if (item.minClickZone) {
      hasOptionFlagsValue += 1 << 2;
    }
  }
  widgetFlags = hasOptionFlags
    ? widgetFlags + (1 << 15)
    : widgetFlags & ~(1 << 15);
  widgetFlags = (widgetFlags & ~0x3f0) + (Number(item.appId) << 0x4);

  const { conditionUid } = item;
  if (conditionUid.length > 0) {
    widgetFlags = widgetFlags + (1 << 15);
  }

  const widgetRecordTable = item.dataTable;

  const bin = Buffer.concat([
    widgetName,
    widgetBg,
    widgetUidPreviewImg ? widgetUidPreviewImg : uint32(0),
    widgetRecordCount,
    groupType ?? uint8(0),
    uint16(widgetFlags),
    widgetRecordTable,
    uidEditBoxImg ? uidEditBoxImg : Buffer.alloc(0),
    uidIconImg ? uidIconImg : Buffer.alloc(0),
    item.w && item.h ? whId : Buffer.alloc(0),
    uidJs
      ? uidJs
      : args
      ? args == 'battery'
        ? uint32(25)
        : uint32(Number(args))
      : Buffer.alloc(0),
    alignId,
    hasOptionFlags ? uint32(hasOptionFlagsValue) : Buffer.alloc(0),
    item.translateGroupTypeUid ? item.translateGroupTypeUid : Buffer.alloc(0),
    ...conditionUid,
    item.optionalAppBuf
  ]);
  return bin;
};
